const _callbacks = {};

export function on(eventName, callback) {
	if (!_callbacks[eventName]) {
		_callbacks[eventName] = [];
	}
	_callbacks[eventName].push(callback);
}

export function off(eventName, callback) {
	const callbacks = _callbacks[eventName];
	if (!callbacks) {
		return;
	}

	let index = -1;
	for (let i = 0; i < callbacks.length; i++) {
		if (callbacks[i] === callback) {
			index = i;
			break;
		}
	}

	if (index < 0) {
		return;
	}

	_callbacks[eventName].splice(index, 1);
}

export function trigger(eventName) {
	const callbacks = _callbacks[eventName];
	if (!callbacks || !callbacks.length) {
		return;
	}

	const args = Array.prototype.slice.call(arguments, 1);
	let success = true;
	for (let i = 0; i < callbacks.length; i++) {
		const result = callbacks[i].apply(this, args);
		if(result === false) {
			success = false;
		}
	}
	return success;
}

export default {
	on, off, trigger
};


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/event.js